import React from 'react'
import Subheader from '../../component/Subheader'
import WeddingStory from './WeddingStory'
import WeddingGallery from './WeddingGallery'
import WeddingExperience from './WeddingExperience'
import WeddingMoment from './WeddingMoment'
import WeddingSlider from './WeddingSlider'

const storyData = {
  title: "From your first site visit to the final farewell, our dedicated team handles every logistical detail so you can focus entirely on your moment.",
  description: "Your wedding finds its perfect rhythm against the raw, stunning backdrop of the Corbett wilderness. Whether you are envisioning an intimate ceremony under a canopy of ancient trees or a vibrant celebration on our expansive green lawns, our wedding experts are here to make that happen. We handle the glory of traditional ceremonies with the same care and creativity we bring to minimalist, modern gatherings. Whatever your dream looks like, we are here to ground it in nature and bring your story to life.",
}

const subheadData = {
  heading: 'Destination Wedding in Jim Corbett',
  breadcrumb: [
    {
      slug: "/resort-de-coracao-corbett",
      name: "Jim Corbett",
    },
    {
      slug: "",
      name: "Weddings",
    },
  ]
}

const slideData = {
  newClass: "",
  heading: "Complete Wedding Celebrations",
  slides: [
    {
      image: "/image/wedding-slide-1.webp",
      title: "Engagement <br /> Ceremony",
      desc: "Celebrate your Engagement Ceremony at De Coracao Resort in a setting of elegance, warmth, and timeless charm."
    },
    {
      image: "/image/wedding-slide-2.webp",
      title: "Mehendi <br /> Ceremony",
      desc: "Celebrate your Mehendi Ceremony at De Coracao Resort with vibrant décor and festive charm."
    },
    {
      image: "/image/wedding-slide-3.webp",
      title: "Haldi <br /> Ceremony",
      desc: "Host your Haldi Ceremony at De Coracao Resort in a radiant setting filled with warmth and celebration."
    },
    {
      image: "/image/wedding-slide-4.webp",
      title: "Sangeet <br /> Night",
      desc: "Host your Sangeet Night at De Coracao Resort with vibrant music and a lively festive atmosphere."
    },
  ]

}

export default function Wedding() {
  return (
    <>
      <Subheader subheadData={subheadData} />
      <WeddingStory data={storyData} />
      <WeddingGallery />
      <WeddingExperience />
      <WeddingMoment />
      <WeddingSlider data={slideData} />
    </>
  )
}
